const OTP_SESSION_EMAIL_KEY = 'otpVerificationEmail'
const OTP_SESSION_EXPIRY_KEY = 'otpVerificationExpiry'
const DEFAULT_OTP_DURATION_SECONDS = 120

export const getOtpDurationSeconds = (minutes: string | number | undefined) => {
  const parsedMinutes = Number(minutes)

  if (!Number.isFinite(parsedMinutes) || parsedMinutes <= 0) {
    return DEFAULT_OTP_DURATION_SECONDS
  }

  return parsedMinutes * 60
}

export const setOtpSession = (email: string, durationSeconds: number) => {
  sessionStorage.setItem(OTP_SESSION_EMAIL_KEY, email)
  sessionStorage.setItem(OTP_SESSION_EXPIRY_KEY, `${Date.now() + durationSeconds * 1000}`)
}

export const getOtpSessionEmail = () => sessionStorage.getItem(OTP_SESSION_EMAIL_KEY) || ''

export const getOtpSessionExpiry = () => {
  const storedExpiry = Number(sessionStorage.getItem(OTP_SESSION_EXPIRY_KEY))

  if (!Number.isFinite(storedExpiry) || storedExpiry <= 0) {
    return null
  }

  return storedExpiry
}

export const clearOtpSession = () => {
  sessionStorage.removeItem(OTP_SESSION_EMAIL_KEY)
  sessionStorage.removeItem(OTP_SESSION_EXPIRY_KEY)
}
